import './Icon.scss';

import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ReactTooltip from 'react-tooltip';
import Constants from 'Shared/constants';

const Icon = ({
	id,
	iconWeight,
	icon,
	color,
	size,
	style,
	onClick,
	className,
	tooltip,
	badge,
	spaceAfter,
	spaceBefore,
	tooltipLanguageKey,
	tooltipLanguageNamespace
}) => {
	const { t } = useTranslation(tooltipLanguageNamespace);

	const componentId = id || `react__icon-${String(Math.random()).replace('.', '')}-${Date.now()}`;
	const onClickProps = {};
	if (onClick !== null) {
		onClickProps.onClick = () => onClick();
		onClickProps.role = 'button';
		onClickProps.tabIndex = 0;
	}

	useEffect(() => {
		ReactTooltip.rebuild();
	}, [tooltip, tooltipLanguageKey]);

	const getTooltip = () => {
		if (tooltip) {
			return tooltip;
		}
		if (tooltipLanguageKey) {
			return t(tooltipLanguageKey);
		}
		return null;
	};

	return (
		<>
			<span className='react__icon-wrapper' data-size={size} data-space-after={spaceAfter} data-space-before={spaceBefore}>
				<i
					className={`react__icon ${iconWeight} ${icon} ${color} ${size} ${className}`}
					data-has-badge={badge !== null}
					data-has-clickevent={onClick !== null}
					data-tip={getTooltip()}
					id={componentId}
					style={style}
					{...onClickProps}
				>
					{badge}
				</i>
			</span>
		</>
	);
};

Icon.propTypes = {
	id: PropTypes.string,
	iconWeight: PropTypes.oneOf(['fas', 'far', 'fal', 'fab']),
	icon: PropTypes.string.isRequired,
	color: PropTypes.oneOf(Constants.TYPES),
	size: PropTypes.oneOf(Constants.SIZES),
	style: PropTypes.object,
	onClick: PropTypes.func,
	className: PropTypes.string,
	tooltip: PropTypes.string,
	tooltipLanguageNamespace: PropTypes.string,
	tooltipLanguageKey: PropTypes.string,
	badge: PropTypes.object,
	spaceAfter: PropTypes.bool,
	spaceBefore: PropTypes.bool
};

Icon.defaultProps = {
	id: null,
	iconWeight: 'fas',
	color: 'extraDarkSmoke',
	size: 'l',
	style: {},
	onClick: null,
	className: '',
	tooltip: null,
	tooltipLanguageKey: null,
	tooltipLanguageNamespace: 'viatoUi',
	badge: null,
	spaceAfter: false,
	spaceBefore: false
};

export default Icon;
